import { useMutation, useQueryClient } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { CORE_API_SUFFIX, dataFetch } from '../../../axios/customAxios';
import { useOrganizationSettingsStore } from '../../../store/organizationSettingsStore';

interface UpdateOnboardingStepRequest {
  step: string;
  status: 'pending' | 'in_progress' | 'completed';
}

export const useUpdateOnboardingStep = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const setOnboardingFinished = useOrganizationSettingsStore((state) => state.setOnboardingFinished);

  return useMutation(
    ({ step, status }: UpdateOnboardingStepRequest) => dataFetch.patch(
      `${CORE_API_SUFFIX}onboarding/steps/${step}`,
      { status },
    ),
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries(['onboarding-steps']);
        if (variables.step === 'complete') {
          setOnboardingFinished(true);
          navigate('/dashboard');
        }
      },
    },
  );
};
